/**
 * 全局状态更新store
 * 使用指南：
 * 此轮询因为涉及到问答，所以一直会轮询，当需要执行其他轮询时，
 * 使用setInfos插入轮询的类型，并设置相应的入参，即可调起轮询
 */
import {makeObservable, observable, action, flow} from 'mobx';
import _ from 'lodash';
import {getQueryProgress} from '../services';

export class TaskStore {
    infos = [];// 任务列表
    anchorIds = [];// 主播id列表
    scriptIds = [];// 脚本id列表
    liveScriptList = [];// 直播状态脚本
    createAnchorList = [];// 生成中脚本
    externalScriptList = [];// 对外推流脚本
    videoScriptList = [];// 视频脚本
    aiQA = {};// AI问答
    aiScript = {};// AI脚本
    time = 5000;// 轮询时间
    constructor() {
        makeObservable(this, {
            infos: observable,
            anchorIds: observable,
            scriptIds: observable,
            liveScriptList: observable,
            createAnchorList: observable,
            externalScriptList: observable,
            videoScriptList: observable,
            aiQA: observable,
            aiScript: observable,
            fetchProgress: action,
            setInfos: action,
            setAnchorIds: action,
            setScriptIds: action,
            setTime: action,
            resetTask: action
        });
    }

    resetTask = () => {
        this.infos = [];
        this.anchorIds = [];
        this.scriptIds = [];
        this.liveScriptList = [];
        this.createAnchorList = [];
        this.externalScriptList = [];
        this.videoScriptList = [];
        this.aiQA = {};
        this.aiScript = {};
    };

    fetchProgress = flow(function* () {
        try {
            const {errno, data} = yield getQueryProgress({
                infos: this.infos,
                smart_anchor_ids: this.anchorIds,
                live_room_script_ids: this.scriptIds,
                video_info_script_ids: this.scriptIds,
                external_room_script_ids: this.scriptIds
            });
            if (+errno === 0 && data) {
                const {
                    ai_qa_progress: aiQAProgress = {},
                    ai_script_progress: aiScriptProgress = {},
                    smart_anchor_list: smartAnchorList = {},
                    live_room_info: liveRoomInfo = {},
                    video_info: videoInfo = {},
                    external_room_info: externalRoomInfo = {}
                } = data;
                this.liveScriptList = liveRoomInfo.script_list || [];
                this.createAnchorList = smartAnchorList.list || [];
                this.externalScriptList = externalRoomInfo.script_list || [];
                this.videoScriptList = videoInfo.script_list || [];
                this.aiQA = aiQAProgress;
                this.aiScript = aiScriptProgress;
            }
        }
        catch (error) {
            console.log(error);
        }

    });

    setAnchorIds = (ids) => {
        this.anchorIds = _.uniq([...this.anchorIds, ...ids]);
    };

    setScriptIds = (ids) => {
        this.scriptIds = _.uniq([...this.scriptIds, ...ids]);
    };

    setInfos = (...info) => {
        this.infos = _.uniq([...this.infos, ...info]);
    };

    setTime = (time) => {
        this.time = time;
    };

}
